import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import Translation from '../translation/translation';

function TyreIndexExplanationLightbox({ visible, onClose }) {
    return (
        <Lightbox
            opened={visible}
            onClose={onClose}
            additionalClassNames={['tyre-index-explanation-lightbox__lightbox']}
        >
            <div className="tyre-index-explanation-lightbox">
                <Translation
                    translationKey="tyre-index-explanation-lightbox-header"
                    className="tyre-index-explanation-lightbox__header"
                    tagName="div"
                />
                <Translation
                    translationKey="tyre-index-explanation-lightbox-content"
                    className="tyre-index-explanation-lightbox__content"
                    tagName="div"
                />
            </div>
        </Lightbox>
    );
}

TyreIndexExplanationLightbox.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { TyreIndexExplanationLightbox };
